import { render } from "./coupons.vue?vue&type=template&id=baec8d0c"
import script from "./coupons.vue?vue&type=script&lang=js"
export * from "./coupons.vue?vue&type=script&lang=js"

import "./coupons.vue?vue&type=style&index=0&id=baec8d0c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__